import React from 'react'
import { SvgIcon } from '@material-ui/core'

function CloseSmallIcon(props) {
  return (
    <SvgIcon viewBox='0 0 16 16' {...props}>
      <path
        id='Line 5 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76262 11.1366C4.61758 10.9916 4.61758 10.7564 4.76262 10.6114L10.7121 4.66189C10.8572 4.51685 11.0923 4.51685 11.2374 4.66189C11.3824 4.80694 11.3824 5.0421 11.2374 5.18714L5.28787 11.1366C5.14283 11.2817 4.90767 11.2817 4.76262 11.1366Z'
        stroke-width='0.5'
        stroke-linecap='round'
      />
      <path
        id='Line 5 (Stroke)_2'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.76262 4.77839C4.61758 4.92344 4.61758 5.1586 4.76262 5.30364L10.7121 11.2531C10.8572 11.3982 11.0923 11.3982 11.2374 11.2531C11.3824 11.1081 11.3824 10.8729 11.2374 10.7279L5.28787 4.77839C5.14283 4.63335 4.90767 4.63335 4.76262 4.77839Z'
        stroke-width='0.5'
        stroke-linecap='round'
      />
    </SvgIcon>
  )
}

export default CloseSmallIcon
